const cookieTableStructure = {
    caption: 'Verwendete Cookies',
    headers: {
        name: 'Name',
        description: 'Zweck',
        duration: 'Dauer',
    },
};

const de = {
    consentModal: {
        label: 'Informationen zu Ihrer Privatsphäre auf dieser Website',
        title: 'Ihre Privatsphäre',
        description: `
            <p>Ihre Privatsphäre ist uns wichtig, daher erfassen wir keine personenbezogenen Daten ohne Ihre Zustimmung. Hier können Sie der Nutzung von externen Anbietern für eingebettete Inhalte und zur Erfassung von Besucher-Statistiken zustimmen, dieser widersprechen oder individuelle Einstellungen treffen.</p>
            {{revisionMessage}}`,
        acceptAllBtn: 'Alle akzeptieren',
        acceptNecessaryBtn: 'Nur notwendige',
        showPreferencesBtn: 'Individuelle Einstellungen',
        revisionMessage:
            '<p>Wir haben Änderungen an den Privatsphäre-Optionen vorgenommen. Bitte prüfen Sie Ihre Einstellungen.</p>',
        footer: `
            <a href="/datenschutz">Datenschutzerklärung</a>
            <a href="/impressum">Impressum</a>
        `,
    },
    preferencesModal: {
        title: 'Privatsphäre-Einstellungen',
        acceptAllBtn: 'Alle akzeptieren',
        acceptNecessaryBtn: 'Nur notwendige',
        savePreferencesBtn: 'Einstellungen speichern',
        closeIconLabel: 'Einstellungen schließen',
        sections: [
            {
                description:
                    'Hier können Sie einstellen, welche Cookies und externen Services wir verwenden dürfen, von denen gegebenenfalls personenbezogene Daten erfasst werden. Mehr erfahren Sie in unserer <a href="/datenschutz" class="cc__link">Datenschutzerklärung</a>.',
            },
            {
                title: 'Technisch erforderlich',
                description:
                    'Die hier genannten Cookies sind technisch erforderlich, um Ihre Privatsphäre-Einstellungen zu speichern und gefälschte Formular-Einreichungen zu verhindern.',
                linkedCategory: 'necessary',
                cookieTable: {
                    ...cookieTableStructure,
                    body: [
                        {
                            name: 'privacy_preferences',
                            description: 'Speichert Ihre Privatsphäre-Einstellungen',
                            duration: '365 Tage',
                        },
                        {
                            name: 'CRAFT_CSRF_TOKEN',
                            description: 'Verhindert gefälschte Formulareingaben',
                            duration: 'Session',
                        },
                        {
                            name: 'CraftSessionId',
                            description: 'Sitzungs-Cookie für angemeldete Benutzer',
                            duration: 'Session',
                        },
                    ],
                },
            },
            {
                title: 'Statistik',
                description:
                    'Wir verwenden die selbst-gehostete Open-Source-Software Matomo, um Besucherstatistiken zu erstellen. Hierbei werden Ihre Daten pseudonymisiert verarbeitet. Ihre Daten aus unterschiedlichen Sitzungen werden nicht zusammengeführt, wir erstellen kein Profil von Ihrem Nutzerverhalten und wir verwenden keine Cookies in Matomo.',
                linkedCategory: 'analytics',
            },
            {
                title: 'Marketing',
                description:
                    'Wir verwenden OneSignal, um Ihnen browserbasierte Push-Benachrichtigungen anzubieten. Nach der Aktivierung können Sie Push-Benachrichtigungen über Ihren Browser abonnieren.',
                linkedCategory: 'marketing',
            },
            {
                title: 'Externe Medien',
                description:
                    'Mit dieser Kategorie können Sie eingebettete Medien von den aufgelisteten externen Anbietern aktivieren. Dabei können personenbezogene Daten an die jeweiligen Anbieter übertragen werden.',
                linkedCategory: 'media',
            },
        ],
    },
};

export { de };
